interface STLValidationResult {
  isValid: boolean;
  error?: string;
  triangles?: number;
}

export const validateSTL = async (file: File): Promise<STLValidationResult> => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const buffer = e.target?.result as ArrayBuffer;
      
      // Arquivo muito pequeno para ser um STL válido
      if (buffer.byteLength < 84) {
        resolve({ 
          isValid: false, 
          error: 'Arquivo STL inválido ou corrompido' 
        });
        return;
      }

      const view = new DataView(buffer);
      
      try {
        // Verifica se é binário ou ASCII
        const header = new Uint8Array(buffer, 0, 5);
        const headerText = new TextDecoder().decode(header).toLowerCase();
        
        if (headerText.includes('solid')) {
          // STL ASCII
          const content = new TextDecoder().decode(buffer);
          if (!content.includes('facet normal') || !content.includes('outer loop')) {
            resolve({ 
              isValid: false, 
              error: 'Arquivo STL ASCII inválido' 
            });
            return;
          }
        } else {
          // STL Binário
          const triangleCount = view.getUint32(80, true);
          const expectedSize = 84 + (triangleCount * 50);
          
          if (buffer.byteLength !== expectedSize) {
            resolve({ 
              isValid: false, 
              error: 'Arquivo STL binário corrompido' 
            });
            return;
          }
          
          resolve({ 
            isValid: true, 
            triangles: triangleCount 
          });
        }
        
        resolve({ isValid: true });
      } catch (error) {
        resolve({ 
          isValid: false, 
          error: 'Erro ao processar arquivo STL' 
        });
      }
    };

    reader.onerror = () => {
      resolve({ 
        isValid: false, 
        error: 'Erro ao ler o arquivo' 
      });
    };

    reader.readAsArrayBuffer(file);
  });
}; 